import { Component } from '@angular/core';

@Component({
  selector: 'rid-mechanic-wrapper',
  templateUrl: './rid-mechanic-wrapper.html',
  host: {
    class: 'block relative flex h-full flex-col overflow-hidden',
  },
})
export class RidMechanicWrapper {}
